module.exports = __webpack_public_path__ + "static/img/289_TO8_2456_og.75ea3a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/289_TO8_2456_og.jpg
// module id = GrgT
// module chunks = 0